import React, { useState, useEffect } from 'react';
import './calendarOffline.css';
import { getDates } from "../../helpers/getDates";

const CalendarOffline = ({ date, handler, open, close, style }) => {
    // Если не передана дата, или дата пустая строка
    if (!date) {
        date = new Date().toLocaleDateString('fr-CA');
    }

    const [dates, setDates] = useState({});

    // Переключение месяца
    const changeMonth = d => {
        setDates(getDates(d));
    };

    useEffect(() => {
        setDates(getDates(date));
    }, [date]);


    // Обработчик клика
    const clickHandler = event => {
        if (open && !event.target?.closest('.calend')) {
            close();
        }
    };

    useEffect(() => {
        document.addEventListener('click', clickHandler);

        return () => document.removeEventListener('click', clickHandler);
    }, [open]);

    if (!open) return false;

    return (
        <div className="calend" style={ style }>
            <div className="calend__header">
                <div className="calend__navs">
                    <i
                        className="calend__nav calend__nav--prev"
                        onClick={ () => changeMonth(dates.prev) }
                    />
                    <i
                        className="calend__nav calend__nav--next"
                        onClick={ () => changeMonth(dates.next) }
                    />
                </div>
                <div className="calend__month">{ dates.monthYear }</div>
            </div>
            <div className="calend__days">
                <div className="calend__day">Пн</div>
                <div className="calend__day">Вт</div>
                <div className="calend__day">Ср</div>
                <div className="calend__day">Чт</div>
                <div className="calend__day">Пт</div>
                <div className="calend__day calend__day--weekend">Сб</div>
                <div className="calend__day calend__day--weekend">Вс</div>
            </div>
            <div className="calend__items">
                {
                    dates.days?.map((item, index) => {
                        return (
                            <div
                                key={ index }
                                className={
                                    `calend__item ${ dates.today === item.date ? 'calend__item--today' : '' }`
                                }
                                onClick={ () => handler(item.date) }
                            >{ item.day }</div>
                        )
                    })
                }
            </div>
            <div className="calend__today"
                onClick={ () => {
                    handler(dates.today);
                } }
            >Сегодня</div>
        </div>
    );
};

export default CalendarOffline;